import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconArchive.module.css';

const IconArchive = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <path d="m41.09 10.45-2.77-3.36A3.04 3.04 0 0 0 36 6H12c-.93 0-1.76.43-2.31 1.09l-2.77 3.36C6.34 11.15 6 12.03 6 13v25c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V13c0-.97-.34-1.85-.91-2.55M24 35 13 24h7v-4h8v4h7zM10.25 10l1.63-2h24l1.87 2z"></path>
      <path fill="none" d="M0 0h48v48H0z"></path>
    </svg>
  );
};

IconArchive.defaultProps = { className: null, rootClassName: null };

IconArchive.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconArchive;
